/*
==========================================================
MODULE FILTERS
==========================================================
*/

import "./ModuleFilters.css";

const ModuleFilters = ({ children }) => {

  return (

    <section className="module-filters">

      {children}

    </section>

  );

};

export default ModuleFilters;